import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangePasswordFormComponent} from "./change-password-form/change-password-form.component";
import {PersonalConfigComponent} from './personal-config.component';
import {AppSettingsComponent} from './app-settings/app-settings.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/components/inputtext/inputtext";
import {ButtonModule} from "primeng/components/button/button";
import {PanelModule} from "primeng/components/panel/panel";
import {FieldsetModule} from "primeng/components/fieldset/fieldset";
import {SharedModule} from "primeng/components/common/shared";
import {InputSwitchModule} from 'primeng/primeng';
import {RouterModule} from "@angular/router";
import {TabViewModule} from "primeng/components/tabview/tabview";
import {RadioButtonModule} from "primeng/components/radiobutton/radiobutton";

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        PanelModule,
        FieldsetModule,
        InputTextModule,
        InputSwitchModule,
        ButtonModule,
        TabViewModule,
        RadioButtonModule
    ],
    declarations: [ChangePasswordFormComponent, PersonalConfigComponent, AppSettingsComponent]
})
export class PersonalConfigModule {
}



// WEBPACK FOOTER //
// ./src/app/personal-config/personal-config.module.ts